var render = function render(){var _vm=this,_c=_vm._self._c;return _c('baremetal-list',{attrs:{"hiddenFilterOptions":['host'],"id":_vm.id,"getParams":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }